import { Link } from "@remix-run/react";
import { getImageUrl } from "~/utils";

interface RelatedMediaCardProps {
  id: number;
  name: string;
  subtitle?: string;
  description: string;
  firstPicture: {
    id: string;
    name: string;
    file: {
      url: string;
      thumb: {
        url: string;
      };
      small: {
        url: string;
      };
      slider?: {
        url: string;
      };
    };
  };
  mediaKindsAsString: string;
  secondaryEducationAsString: string;
  extent?: {
    id: number;
    name: string;
  };
  linkTo: string;
}

export default function RelatedMediaCard({
  id,
  name,
  subtitle,
  description,
  firstPicture,
  mediaKindsAsString,
  secondaryEducationAsString,
  extent,
  linkTo,
}: RelatedMediaCardProps) {
  return (
    <Link
      to={linkTo}
      className="flex gap-1 rounded-lg bg-white py-1  hover:bg-gray-50"
    >
      {/* Thumbnail */}
      <div className="mr-2 flex-shrink-0">
        {firstPicture ? (
          <img
            loading="lazy"
            alt={name}
            className="h-18 w-32 rounded-md object-cover"
            src={getImageUrl(
              firstPicture.file.thumb?.url || firstPicture.file.url
            )}
          />
        ) : (
          <div className="flex h-18 w-32 items-center justify-center rounded-md bg-gray-200">
            <svg
              className="h-10 w-10 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>
        )}
      </div>

      {/* Content */}
      <div className="flex-1 overflow-hidden">
        {/* Title */}
        <h4
          className="mb-1 overflow-hidden text-sm font-bold text-gray-900"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {name}
        </h4>

        {/* Subtitle or description snippet */}
        {subtitle && (
          <p className="mb-2 text-xs font-semibold text-gray-400">{subtitle}</p>
        )}

        {/* Metadata */}
        <div className="flex flex-wrap gap-x-2 gap-y-1 text-xs font-semibold text-gray-400">
          {extent && (
            <p className="text-xs font-semibold text-gray-400">{extent.name}</p>
          )}
          <span className="mx-1 text-gray-400">|</span>
          {mediaKindsAsString && <span>{mediaKindsAsString}</span>}
          <span className="mx-1 text-gray-400">|</span>
          <span>{secondaryEducationAsString}</span>
        </div>
      </div>
    </Link>
  );
}
